const GROUPS = [
  { title: "追瓜", links: ["吃瓜热榜", "热议进行时", "舆论风向", "瓜田速览", "话题广场"] },
  { title: "专区", links: ["娱乐·综艺", "民生·社会", "商业·财经", "科技·互联网"] },
  { title: "关于", links: ["站点介绍", "内容投稿", "意见反馈", "合作联系"] },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/50 border-t border-background-300/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-10 md:pt-12 pb-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* 品牌 */}
          <div className="col-span-2 md:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-xl bg-gradient-to-br from-primary-500 to-accent-600 flex items-center justify-center text-background-50">
                <i className="ri-fire-fill" aria-hidden="true"></i>
              </span>
              <span className="font-display font-black text-xl text-foreground-950">
                58<span className="text-primary-600">黑料</span>
              </span>
            </a>
            <p className="text-xs text-foreground-600 leading-relaxed mt-4">
              吃瓜围观第一线，汇聚热议评论与瓜田动态，从事件发酵到舆论风向，不错过任何精彩瞬间。
            </p>
            <div className="flex items-center gap-3 mt-4">
              {["ri-weibo-line", "ri-wechat-line", "ri-youtube-line", "ri-twitter-x-line"].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="社交平台"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 border border-background-200/70 text-foreground-700 hover:text-primary-600 hover:border-primary-200 transition-colors cursor-pointer"
                >
                  <i className={ic} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {/* 链接组 */}
          {GROUPS.map((g) => (
            <div key={g.title}>
              <h4 className="font-bold text-foreground-950 text-sm mb-3">{g.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {g.links.map((l) => (
                  <li key={l}>
                    <a href="#top" className="text-[13px] text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 免责声明 */}
        <div className="mt-8 rounded-xl bg-background-100/80 border border-background-200/70 p-4">
          <p className="text-[11px] leading-relaxed text-foreground-600">
            本页内容为聚合整理与讨论导览示例，仅用于信息展示与娱乐化呈现，不构成对任何个人、机构或事件的定性结论。讨论内容请理性表达、友善参与。
          </p>
        </div>

        {/* 版权条 */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-6 pt-5 border-t border-background-300/60">
          <p className="text-xs text-foreground-600">© 2026 58黑料 · 吃瓜围观现场。仅供演示。</p>
          <a href="#top" className="flex items-center gap-1 text-xs text-foreground-600 hover:text-primary-600 cursor-pointer">
            回到顶部 <i className="ri-arrow-up-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}